<template>
  <section id="panel-tests" v-loading.fullscreen.lock="loading">
    <div class="added-tests-view">
      <div class="update-test-btn">
        <div class="case-status pb-0" v-if="getAllTestPanels">
          <div class="status-preview" v-if="this.selectedPanel.status">
            <el-dropdown
              v-if="hasPermission('test_panels', 'update_status')"
              @command="(command) => changeStatus(command, panelId)"
              trigger="click"
            >
              <el-button :class="getStatusType(this.selectedPanel.status)">
                <span class="pr-5">{{ this.selectedPanel.status }}</span>
              </el-button>

              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    command="ACTIVE"
                    v-if="this.selectedPanel.status !== 'ACTIVE'"
                  >
                    <span class="px-10">ACTIVE</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    command="INACTIVE"
                    v-if="this.selectedPanel.status !== 'INACTIVE'"
                  >
                    <span class="px-10">INACTIVE</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <el-button class="edit-btn" @click="updateTests()">
          <span>Edit</span>

          <img src="@/assets/images/icons/profile/edit-icon.svg" alt="icon" />
        </el-button>
      </div>
      <div class="content" v-if="selectedPanel && selectedPanelTests.length">
        <div class="add-tests-tabs">
          <div class="test-groups">
            <ul class="all-tests">
              <li
                class="each-test"
                v-for="(category, index) of getCaseCategoryData()"
                :key="index"
              >
                <h3
                  class="test-group-title"
                  :class="
                    this.selectedPanel.status !== 'ACTIVE'
                      ? 'Status-active'
                      : 'Status-Inactive'
                  "
                >
                  <img src="@/assets/images/icons/each-panel-icon.svg" />

                  <span class="ml-10">
                    {{ category.category }}
                  </span>
                </h3>
                <ul class="sub-test-list">
                  <li
                    v-for="(item, index) of getCategoryWiseTestsData(
                      category.category_code
                    )"
                    :key="index"
                  >
                    <img
                      src="@/assets/images/icons/success-medication-blue.svg"
                    />
                    <p class="test-name">
                      {{ item.name }}
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="vue-model add-test-model">
        <el-dialog
          top="5vh"
          v-model="showTestPanelSelectionDialogVisible"
          width="80%"
        >
          <AddTests
            :labId="labId"
            :isNew="false"
            v-on:addTestsData="closeAddTests"
            v-on:addedPanel="updatePanels"
            :selectedTestIds="selectedTestIds"
            :panelValue="panelValue"
          />
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import AddTests from "./panels/AddTests";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      cardloading: false,
      allTestPanels: [],
      checkList: [],
      selectedData: [],
      params: {
        lab_id: this.$route.params.lab_id,
        panelType: "",
        details: true,
      },
      data: {},
      allData: [],
      panelTests: [],
      panelVisible: false,
      addPanelVisible: false,
      selectedPanelType: "",
      selectedPanelTypeCode: "",
      selectedPanelTypeName: "",
      selectedPanel: {},
      selectedPanelTests: [],
      activeNameCollapse: "",
      searchString: "",
      testsData: [],
      showTestPanelSelectionDialogVisible: false,
      status: ["ACTIVE", "INACTIVE"],
    };
  },
  name: "TestPanel",
  components: { AddTests },
  props: ["isNew", "panelValue", "labId"],
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("testpanel", [
      "getAllTestPanels",
      "getTestPanelsByLabId",
      "getTestPanelUpdateStatus",
    ]),
    ...mapGetters("labs", ["getTestPanels"]),
    panelId() {
      return this.selectedPanel._id;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "ACTIVE") {
          return "btn-success";
        } else if (status == "INACTIVE") {
          return "btn-danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    this.params.code = this.panelValue;
    await this.fetAllNessaryData();
  },
  methods: {
    async changeStatus(command, id) {
      if (command == this.selectedPanel.status) {
        return;
      }
      let params = {
        status: command,
        test_panel_id: id,
      };
      await this.updateStatus(params);
    },
    async updateStatus(params) {
      this.loading = true;
      await this.$store.dispatch("testpanel/changeTestPanelStatus", params, {
        root: true,
      });
      this.loading = false;
      if (
        this.getTestPanelUpdateStatus &&
        this.getTestPanelUpdateStatus.success
      ) {
        successNotification(this.getTestPanelUpdateStatus.message);
        this.selectedPanel.status = params.status;
        window.location.reload();
      }
    },
    async fetAllNessaryData() {
      await this.fetchAllDefaultTestsForPanel();

      if (!this.isNew) {
        await this.fetchLabTestsForPanel();
      }
    },

    closeAddTests(status) {
      this.showTestPanelSelectionDialogVisible = false;
      if (status) {
        this.fetAllNessaryData();
      }
    },
    updatePanels(status) {
      this.showTestPanelSelectionDialogVisible = false;
      if (status) {
        this.fetAllNessaryData();
      }
    },
    async viewPanelTests() {
      try {
        await this.$store.dispatch("testpanel/fetchTestPanels", this.params);
        this.panelVisible = true;
      } catch (err) {
        console.log(err);
      }
    },
    editTests() {
      if (this.showTestSelection) {
        this.showTestSelection = false;
      }
      this.showTestPanelSelectionDialogVisible = true;
      this.newPanel = false;
      this.selectedPanel = this.selectedNewTestPanel;
    },
    async updateTests() {
      this.selectedTestIds = this.selectedPanelTests.map((e) => e._id);
      this.showTestPanelSelectionDialogVisible = true;
    },

    isCheckAll(category) {
      let selectedData = this.getCategoryWiseTestsData(category).map(
        (item) => item._id
      );

      return selectedData.every((item) => {
        return this.testsData.indexOf(item) !== -1;
      });
    },

    checkAll(data, category) {
      let selectedData = this.getCategoryWiseTestsData(category).map(
        (item) => item._id
      );
      if (data) {
        for (let i = 0; i < selectedData.length; i++) {
          if (this.testsData.indexOf(selectedData[i]) == -1) {
            this.testsData.push(selectedData[i]);
          }
        }
      } else {
        for (let i = 0; i < selectedData.length; i++) {
          let index = this.testsData.indexOf(selectedData[i]);
          if (index > -1) {
            this.testsData.splice(index, 1);
          }
        }
      }
    },
    async fetchAllDefaultTestsForPanel() {
      try {
        this.loading = true;
        await this.$store.dispatch("testpanel/fetchTestPanels", {
          code: this.panelValue,
          panel_type: this.panelValue,
          details: true,
          status: this.status,
        });

        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchLabTestsForPanel() {
      try {
        let params = this.params;
        params.status = this.status;

        await this.$store.dispatch("testpanel/fetchTestPanelsByLabId", params);
        if (
          this.getTestPanelsByLabId &&
          this.getTestPanelsByLabId.data &&
          this.getTestPanelsByLabId.data[0]
        ) {
          let data = this.getTestPanelsByLabId.data[0];
          this.selectedPanelTypeName = data.name;
          this.selectedPanelTypeCode = data.code;

          this.selectedPanel =
            this.getTestPanelsByLabId.data &&
            this.getTestPanelsByLabId.data.length
              ? this.getTestPanelsByLabId.data[0]
              : {};

          this.selectedPanelTests =
            this.selectedPanel && this.selectedPanel.tests
              ? this.selectedPanel.tests
              : [];

          if (data) {
            this.testsData = data.tests.map((e) => e._id);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async setSelectedDataIntoDefaultData() {
      let allData = [...new Set(this.getAllTestPanels.data)];
      let panelData = [...new Set(this.getTestPanelsById.data)];
      function comparer(otherArray) {
        return function (current) {
          return (
            otherArray.filter(function (other) {
              return other.code == current.code;
            }).length == 0
          );
        };
      }
      var onlyInA = allData.filter(comparer(panelData));
      return onlyInA;
    },
    changePanelType() {
      let data = this.selectedPanelType.split("-+");
      this.selectedPanelTypeCode = data[0];
      this.selectedPanelTypeName = data[1];
    },
    async viewPanelDetails() {
      this.params.panelType = this.selectedPanelTypeCode
        ? this.selectedPanelTypeCode
        : "";
      this.params.details = true;
      await this.viewPanelTests();
      await this.fetchLabTestsForPanel();
    },
    getSelectedDataObject() {
      this.selectedPanelTests.forEach((test) => {
        if (this.testsData.indexOf(test._id) != -1) {
          this.selectedData.push(test);
        }
      });
    },
    getCaseCategoryData() {
      const data = this.selectedPanelTests;
      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].category_code]) continue;
        flags[data[i].category_code] = true;
        output.push(data[i].category_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },
    getCategoryWiseTestsData(category) {
      if (this.searchString) {
        return this.selectedPanelTests.filter(
          (el) =>
            el.category_code === category &&
            el.name.toLowerCase().includes(this.searchString.toLowerCase())
        );
      }
      return this.selectedPanelTests.filter(
        (el) => el.category_code === category
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.added-tests-view {
  .update-test-btn {
    justify-content: space-between;
    align-items: center;
    display: flex;
    position: relative;
    top: 15px;
    text-align: end;
    padding: 0 5px;
    .edit-btn {
      border: none;
      color: #014f49;
      background-color: transparent;
      padding: 0;
      &:hover,
      &:active,
      &:focus {
        background-color: transparent;
      }
      img {
        position: relative;
        top: 4px;
        left: 5px;
        width: 20px;
      }
    }
    .case-status {
      .status-preview {
        .btn-success,
        .btn-danger {
          min-height: 30px;
          top: 5px;
          position: relative;
        }
      }
    }
  }
  .add-tests-tabs {
    .test-groups {
      .all-tests {
        .each-test {
          border: 1.2px solid #e7e7f7;
          border-radius: 10px;

          margin: 15px 0;

          .test-group-title {
            display: flex;
            color: rgba(0, 0, 0, 0.8);
            background: rgba(231, 231, 247, 0.4);
            border-bottom: 1.2px solid #e7e7f7;
            border-radius: 10px 10px 0px 0px;
            padding: 5px 15px;
          }
          .sub-test-list {
            display: flex;
            flex-wrap: wrap;

            padding: 10px 0 0 50px;
            li {
              width: 25%;
              padding: 3px;

              display: flex;
              align-items: center;
            }
            .test-name {
              color: #014f49;
              padding-left: 7px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
